import axios from "../axiosConfig"; // Adjust the import path accordingly

const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);


const SiteMap = {

    GenerateSiteMap: async () => {

        const apiUrl = `${WebApiUrl}/api/SiteMap/GenerateSiteMap`;

        return await axios.get(apiUrl,
            {}
            , {

                withCredentials: true,
                credentials: 'include',
            });
    }

};

export default SiteMap;
